import React from 'react';

const RibbonIcon = () => <i className="icon-ribbon1" />;

export default RibbonIcon;
